import { buildModelManager } from "../builder.js";
const DefaultSubcontractInviteSelection = {
  __typename: true,
  id: true,
  cancelledAt: true,
  contractorWorkItemId: true,
  createdAt: true,
  deletedAt: true,
  openMarketplace: true,
  parentWorkItemId: true,
  priceCeiling: true,
  quoteRequiredBy: true,
  scope: true,
  serviceAreaH3: true,
  serviceAreaPostcode: true,
  targetProfileId: true,
  tradeRequired: true,
  updatedAt: true,
  withdrawnAt: true
};
const modelApiIdentifier = "subcontractInvite";
const pluralModelApiIdentifier = "subcontractInvites";
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSubcontractInviteSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSubcontractInviteSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSubcontractInviteSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSubcontractInviteSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSubcontractInviteSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSubcontractInviteSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSubcontractInviteSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "cancelSubcontractInvite",
    operationReturnType: "CancelSubcontractInvite",
    functionName: "cancel",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      subcontractInvite: { required: false, type: "CancelSubcontractInviteInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSubcontractInviteSelection
  },
  {
    type: "action",
    operationName: "bulkCancelSubcontractInvites",
    functionName: "bulkCancel",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "cancel",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCancelSubcontractInvitesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSubcontractInviteSelection
  },
  {
    type: "action",
    operationName: "restoreSubcontractInvite",
    operationReturnType: "RestoreSubcontractInvite",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      subcontractInvite: { required: false, type: "RestoreSubcontractInviteInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSubcontractInviteSelection
  },
  {
    type: "action",
    operationName: "bulkRestoreSubcontractInvites",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRestoreSubcontractInvitesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSubcontractInviteSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "subcontractInviteGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const SubcontractInviteManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultSubcontractInviteSelection,
  operations
);
export {
  DefaultSubcontractInviteSelection,
  SubcontractInviteManager
};
//# sourceMappingURL=SubcontractInvite.js.map
